export default "__VITE_ASSET__oS9ArRp5__"